<script lang="ts" setup>
import { computed, useAttrs } from 'vue';
import { VLink } from '@/components';
import LocaleSelector from '@/components/elements/layout/LocaleSelector.vue';
import { PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS_URL } from '@/constants/legalLinks';

const homePageUrl = 'https://www.opendock.com';

const attrs = useAttrs();

// Map design-system color tokens to Vuetify v-btn color values.
// "inverted" tokens mean the component sits on a dark background → use white.
const selectorColor = computed(() =>
  String(attrs.color ?? '').includes('inverted') ? 'white' : ''
);
</script>

<template>
  <m-group align="center">
    <v-link v-bind="$attrs" size="small" :href="homePageUrl" target="_blank">
      {{ $t('auth.common.links.opendockWebsite') }}
    </v-link>
    <v-link v-bind="$attrs" size="small" :href="TERMS_AND_CONDITIONS_URL" target="_blank">
      {{ $t('auth.common.links.termsAndConditions') }}
    </v-link>
    <v-link v-bind="$attrs" size="small" :href="PRIVACY_POLICY_URL" target="_blank">
      {{ $t('auth.common.links.privacyPolicy') }}
    </v-link>
    <locale-selector :color="selectorColor" hide-label-on-mobile />
  </m-group>
</template>
